import routes from 'common/constants/routing.constants';
import React, { forwardRef } from 'react';
import {
  clickPageTrack,
  getPathnameForAnalytics,
} from 'common/utils/client-analytics.util';
import { ACCOUNT_TYPES_SWITCH } from 'common/constants/trading.constants';
import history from 'customHistory';
import { inject, observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import {
  PRIMARY_PAGES,
  SECONDARY_PAGES,
} from 'Components/AppLayout/disona/menu.constants';
import { AccountTypeSwitch } from 'Components/AppLayout/disona/Components/AccountTypeSwitch';
import { S } from './styled';

const NavbarElement = ({ isActive, name, Icon, path, t, disabled }) => (
  <S.NavbarItem
    onClick={
      !disabled && clickPageTrack(`go_to_${getPathnameForAnalytics(path)}`)
    }
    active={isActive ? 'true' : ''}
    to={!disabled && path}
  >
    {Icon && (
      <S.NavbarIcon active={isActive ? 'true' : ''}>
        <Icon />
      </S.NavbarIcon>
    )}
    <S.NavbarText>{t(name)}</S.NavbarText>
  </S.NavbarItem>
);

const Sidebar = forwardRef(({ t, AppStore, ProfileStore }, ref) => (
  <S.Container ref={ref}>
    <S.Body>
      <S.Navbar>
        {PRIMARY_PAGES.map((props) => (
          <NavbarElement
            key={props.path}
            {...props}
            t={t}
            isActive={window.location.pathname === props.path}
          />
        ))}
        <S.SiteNavbarDivider />
        {SECONDARY_PAGES.map((props) => (
          <NavbarElement
            key={props.path}
            {...props}
            t={t}
            isActive={window.location.pathname === props.path}
          />
        ))}
        <S.SwitchAccountTypeWrapper>
          <AccountTypeSwitch
            options={ACCOUNT_TYPES_SWITCH}
            onChange={({ item, setOpen }) => {
              if (item.value === 'Real' && ProfileStore.needInfoAndHaveData) {
                history.push(routes.profile.path);
              } else {
                AppStore.changeAccountType(item.value);
                setOpen(false);
              }
            }}
            value={AppStore.getAccountType}
          />
        </S.SwitchAccountTypeWrapper>
      </S.Navbar>
      <S.LogoutContainer onClick={AppStore.logout}>
        {t('common.menu.logout')}
      </S.LogoutContainer>
    </S.Body>
  </S.Container>
));

export default compose(
  inject('AppStore', 'ProfileStore'),
  withTranslation()
)(observer(Sidebar));
